import { ListItemButton, ListItemIcon, ListItemText, MenuItem, MenuItemProps } from '@mui/material';
import { NorthEast } from '@mui/icons-material';
import { PoolBadge } from '@synergy/components-next';
import { ReactElement, ReactNode } from 'react';

type AccountMenuItemProps = MenuItemProps & {
    icon: ReactElement;
    text: ReactNode;
    badgeCount?: number;
    /** Leaves the webshop for another interface; the arrow says so (#2282). */
    external?: boolean;
};

export const AccountMenuItem = (props: AccountMenuItemProps): ReactElement => {
    const { icon, text, badgeCount, external, ...menuItemProps } = props;

    return (
        <MenuItem {...menuItemProps} sx={{ p: 0 }}>
            <ListItemButton>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText>{text}</ListItemText>
                {!!badgeCount && <PoolBadge badgeContent={badgeCount} color="negative" sx={{ ml: 1 }} />}
                {external && <NorthEast sx={{ fontSize: 14, ml: 1, color: 'grey.600' }} />}
            </ListItemButton>
        </MenuItem>
    );
};
